var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-header readonly_header" }, [
      _c("div", { staticStyle: { width: "100%" } }, [
        _c(
          "a",
          {
            staticClass: "text-uppercase text-muted pt-1",
            attrs: { href: "javascript:void(0);" },
            on: { click: _vm.hide }
          },
          [
            _c("img", {
              staticClass: "back_icon mr-2",
              attrs: { src: require("@/assets/manager/back_button_icon.png") }
            }),
            _vm._v("Back")
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close float-right",
            attrs: { type: "button" },
            on: { click: _vm.hide }
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix" })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-body user-info" }, [
      _c("div", { staticClass: "row mb-4" }, [
        _c("div", { staticClass: "col-9 pl-3" }, [
          _c("div", { staticClass: "h5 mr-2" }, [
            _vm._v(_vm._s(_vm.display_firstName + " " + _vm.display_lastName))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h5 mr-2" }, [
            _vm._v(_vm._s(_vm.display_email))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "h6 mr-2" }, [
            _vm._v(_vm._s(_vm.accountName))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 pl-3" })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "loading_show"
        },
        [_c("div", { staticClass: "spinner-border text-danger" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pad-15" }, [
        _c("div", { staticClass: "row edit_row" }, [
          _c("div", { staticClass: "assigned_heading_1 font-weight-bold" }, [
            _vm._v("\n                    Assessments \n                    "),
            _vm.assignedAssessmentsCount > 3 && _vm.assignedAssessmentsCount > 0
              ? _c(
                  "a",
                  {
                    staticClass: "see-more",
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.showMoreAssessments }
                  },
                  [_vm._v(_vm._s(_vm.see_more_assessments_text))]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "assigned_heading_2 font-weight-bold text-center" },
            [_vm._v("Results")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _vm.show_more_assessments === false &&
          _vm.assignedAssessmentsCount > 0
            ? _c(
                "div",
                { staticClass: "row_item_readonly" },
                _vm._l(_vm.lessAssignedAssessments, function(item, lacindex) {
                  return _c(
                    "div",
                    { key: lacindex, staticClass: "row_data_border" },
                    [
                      _c("div", { staticClass: "assigned_heading_1" }, [
                        _vm._v(_vm._s(item.title))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "assigned_heading_2 text-center" },
                        [
                          item.complete_attempt_id
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "link_btn_highlight",
                                  attrs: {
                                    target: "_blank",
                                    to:
                                      "/assessment-report/" +
                                      item.complete_attempt_id
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            View\n                            "
                                  )
                                ]
                              )
                            : _c("span", [_vm._v("n/a")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.show_more_assessments === true && _vm.assignedAssessmentsCount > 0
            ? _c(
                "div",
                { staticClass: "row_item_readonly" },
                _vm._l(_vm.lessAssignedAssessments, function(item, acindex) {
                  return _c(
                    "div",
                    { key: acindex, staticClass: "row_data_border" },
                    [
                      _c("div", { staticClass: "assigned_heading_1" }, [
                        _vm._v(_vm._s(item.title))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "assigned_heading_2 text-center" },
                        [
                          item.complete_attempt_id
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "link_btn_highlight",
                                  attrs: {
                                    target: "_blank",
                                    to:
                                      "/assessment-report/" +
                                      item.complete_attempt_id
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            View\n                            "
                                  )
                                ]
                              )
                            : _c("span", [_vm._v("n/a")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.assignedAssessmentsCount === 0
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "row_item_readonly justify-content-md-center"
                  },
                  [
                    _c("div", { staticClass: "text-red text-center" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getNoRecordText(
                            _vm.assignedAssessmentsCount,
                            "Assessment"
                          )
                        )
                      )
                    ])
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row edit_row" }, [
          _c("div", { staticClass: "assigned_heading_1 font-weight-bold" }, [
            _vm._v("\n                    Forms \n                    "),
            _vm.assignedFormsCount > 3 && _vm.assignedFormsCount > 0
              ? _c(
                  "a",
                  {
                    staticClass: "see-more",
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.showMoreForms }
                  },
                  [_vm._v(_vm._s(_vm.see_more_forms_text))]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "assigned_heading_2 font-weight-bold text-center" },
            [_vm._v("Results")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _vm.show_more_forms === false && _vm.assignedFormsCount > 0
            ? _c(
                "div",
                { staticClass: "row_item_readonly" },
                _vm._l(_vm.lessAssignedForms, function(item, lacindex) {
                  return _c(
                    "div",
                    { key: lacindex, staticClass: "row_data_border" },
                    [
                      _c("div", { staticClass: "assigned_heading_1" }, [
                        _vm._v(_vm._s(item.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "assigned_heading_2 text-center" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "link_btn_highlight",
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.goToViewForm(item.id)
                                }
                              }
                            },
                            [_vm._v("View")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.show_more_forms === true && _vm.assignedFormsCount > 0
            ? _c(
                "div",
                { staticClass: "row_item_readonly" },
                _vm._l(_vm.assignedForms, function(item, acindex) {
                  return _c(
                    "div",
                    { key: acindex, staticClass: "row_data_border" },
                    [
                      _c("div", { staticClass: "assigned_heading_1" }, [
                        _vm._v(_vm._s(item.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "assigned_heading_2 text-center" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "link_btn_highlight",
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.goToViewForm(item.id)
                                }
                              }
                            },
                            [_vm._v("View")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.assignedFormsCount === 0
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "row_item_readonly justify-content-md-center"
                  },
                  [
                    _c("div", { staticClass: "text-red text-center" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getNoRecordText(_vm.assignedFormsCount, "Form")
                        )
                      )
                    ])
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row edit_row" }, [
          _c("div", { staticClass: "assigned_head_1 font-weight-bold" }, [
            _vm._v("\n                    Courses \n                    "),
            _vm.assignedCoursesCount > 3 && _vm.assignedCoursesCount > 0
              ? _c(
                  "a",
                  {
                    staticClass: "see-more",
                    attrs: { href: "javascript:void(0)" },
                    on: { click: _vm.showMoreCourses }
                  },
                  [_vm._v(_vm._s(_vm.see_more_courses_text))]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "assigned_head_2 text-center font-weight-bold" },
            [_vm._v("Final Exam Score")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "assigned_head_3 font-weight-bold" }, [
            _vm._v("Certificate")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _vm.show_more_courses === false && _vm.assignedCoursesCount > 0
            ? _c(
                "div",
                { staticClass: "row_item_readonly" },
                _vm._l(_vm.lessAssignedCourses, function(item, lacindex) {
                  return _c(
                    "div",
                    { key: lacindex, staticClass: "row_data_border" },
                    [
                      _c("div", { staticClass: "courses_item_1" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(item.title) +
                            "\n                            "
                        ),
                        item.score
                          ? _c("span", [
                              _c(
                                "a",
                                {
                                  ref: "show_icon_" + lacindex,
                                  refInFor: true,
                                  staticClass: "show_icon",
                                  on: {
                                    click: function($event) {
                                      return _vm.getCourseModuleInfo(
                                        item.lmsUserId,
                                        item.lmsCourseId,
                                        "course_user_results_modules_" +
                                          lacindex,
                                        lacindex
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/enterprise/down_arrow_image16x16.png"),
                                      width: "16",
                                      height: "16"
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  ref: "hide_icon_" + lacindex,
                                  refInFor: true,
                                  staticClass: "hide_icon",
                                  on: {
                                    click: function($event) {
                                      return _vm.hideCourseModuleInfo(
                                        item.lmsUserId,
                                        item.lmsCourseId,
                                        "course_user_results_modules_" +
                                          lacindex,
                                        lacindex
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/enterprise/up_arrow_image16x16.png"),
                                      width: "16",
                                      height: "16"
                                    }
                                  })
                                ]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "courses_item_2 text-center" }, [
                        item.score
                          ? _c("span", [_vm._v(_vm._s(item.score) + "%")])
                          : _c("span", [_vm._v("n/a")])
                      ]),
                      _vm._v(" "),
                      item.certification_download_link
                        ? _c(
                            "div",
                            { staticClass: "courses_item_3 text-center" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "link_btn_highlight",
                                  attrs: {
                                    href: item.certification_download_link,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("View")]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "courses_item_3 text-center" },
                            [_vm._v("n/a")]
                          ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c("CourseUserResultsModules", {
                        ref: "course_user_results_modules_" + lacindex,
                        refInFor: true
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.show_more_courses === true && _vm.assignedCoursesCount > 0
            ? _c(
                "div",
                { staticClass: "row_item_readonly" },
                _vm._l(_vm.assignedCourses, function(item, acindex) {
                  return _c(
                    "div",
                    { key: acindex, staticClass: "row_data_border" },
                    [
                      _c("div", { staticClass: "courses_item_1" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(item.title) +
                            "\n                            "
                        ),
                        _c(
                          "a",
                          {
                            ref: "show_icon_" + acindex,
                            refInFor: true,
                            staticClass: "show_icon",
                            on: {
                              click: function($event) {
                                return _vm.getCourseModuleInfo(
                                  item.lmsUserId,
                                  item.lmsCourseId,
                                  "course_user_results_modules_" + acindex,
                                  acindex
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/enterprise/down_arrow_image16x16.png"),
                                width: "16",
                                height: "16"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            ref: "hide_icon_" + acindex,
                            refInFor: true,
                            staticClass: "hide_icon",
                            on: {
                              click: function($event) {
                                return _vm.hideCourseModuleInfo(
                                  item.lmsUserId,
                                  item.lmsCourseId,
                                  "course_user_results_modules_" + acindex,
                                  acindex
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/enterprise/up_arrow_image16x16.png"),
                                width: "16",
                                height: "16"
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "courses_item_2 text-center" }, [
                        item.score
                          ? _c("span", [_vm._v(_vm._s(item.score) + "%")])
                          : _c("span", [_vm._v("n/a")])
                      ]),
                      _vm._v(" "),
                      item.certification_download_link
                        ? _c(
                            "div",
                            { staticClass: "courses_item_3 text-center" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "link_btn_highlight",
                                  attrs: {
                                    href: item.certification_download_link,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("View")]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "courses_item_3 text-center" },
                            [_vm._v("n/a")]
                          ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c("CourseUserResultsModules", {
                        ref: "course_user_results_modules_" + acindex,
                        refInFor: true
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.assignedCoursesCount === 0
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "row_item_readonly justify-content-md-center"
                  },
                  [
                    _c("div", { staticClass: "text-red text-center" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getNoRecordText(
                            _vm.assignedCoursesCount,
                            "Course"
                          )
                        )
                      )
                    ])
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.userType === "mentee" || _vm.userType === "apprentice"
          ? _c("div", { staticClass: "row edit_row" }, [
              _c(
                "div",
                { staticClass: "assigned_heading_1 font-weight-bold" },
                [
                  _vm._v(
                    "\n                     Task Lists \n                    "
                  ),
                  _vm.assignedTaskListsCount > 3 &&
                  _vm.assignedTaskListsCount > 0
                    ? _c(
                        "a",
                        {
                          staticClass: "see-more",
                          attrs: { href: "javascript:void(0)" },
                          on: { click: _vm.showMoreTaskLists }
                        },
                        [_vm._v(_vm._s(_vm.see_more_tasklists_text))]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "assigned_heading_2 font-weight-bold text-center"
                },
                [_vm._v("Results")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _vm.show_more_tasklists === false &&
              _vm.assignedTaskListsCount > 0
                ? _c(
                    "div",
                    { staticClass: "row_item_readonly" },
                    _vm._l(_vm.lessAssignedTaskLists, function(item, lacindex) {
                      return _c(
                        "div",
                        { key: lacindex, staticClass: "row_data_border" },
                        [
                          _c("div", { staticClass: "assigned_heading_1" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "assigned_heading_2 text-center" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "link_btn_highlight",
                                  attrs: {
                                    to:
                                      "/enterprise-admin/mentees-task/" +
                                      _vm.accountId +
                                      "/" +
                                      _vm.userId
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                View \n                            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" })
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.show_more_tasklists === true && _vm.assignedTaskListsCount > 0
                ? _c(
                    "div",
                    { staticClass: "row_item_readonly" },
                    _vm._l(_vm.assignedTaskLists, function(item, acindex) {
                      return _c(
                        "div",
                        { key: acindex, staticClass: "row_data_border" },
                        [
                          _c("div", { staticClass: "assigned_heading_1" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "assigned_heading_2 text-center" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "link_btn_highlight",
                                  attrs: {
                                    to:
                                      "/enterprise-admin/mentees-task/" +
                                      _vm.accountId +
                                      "/" +
                                      _vm.userId
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                View \n                            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" })
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.assignedTaskListsCount === 0
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "row_item_readonly justify-content-md-center"
                      },
                      [
                        _c("div", { staticClass: "text-red text-center" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getNoRecordText(
                                _vm.assignedTaskListsCount,
                                "Task List"
                              )
                            )
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44b8beb5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44b8beb5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/view_user_detail_readonly.vue
// module id = null
// module chunks = 